import { useQuery } from "@tanstack/react-query";
import {
	GetCurrentAccountQuery,
	GetCurrentAccountQueryVariables,
} from "~auth/types/__generated/gql/graphql";
import { graphierQLNextClient } from "utils";

const query = /* GraphQL */ `
	query GetCurrentAccount {
		getCurrentAccount {
			id
			createdAt
			updatedAt
			companyName
			slug
			subscription {
				type
				trialExpiresAt
				paidConfig {
					cycle
					plan
					addons {
						admins
						editors
						maps
						storage
					}
					subscriptionID
				}
			}
			paymentMethod {
				cardName
				cardNumber
				cardExpiresAt
				cardCvv
			}
			_currentUserRole
			_recurlyAccountInfo {
				subscription {
					collectionMethod
					plan
					addOns {
						code
						quantity
					}
				}
				hostedToken
				paymentMethod {
					cardType
					lastFour
					expMonth
					expYear
				}
				billingAddress {
					vatNumber
					firstName
					lastName
					streetLine1
					streetLine2
					city
					province
					country
					postalCode
					companyName
				}
			}
		}
	}
`;

export type GetCurrentAccountVariables = GetCurrentAccountQueryVariables;
export type GetCurrentAccountResults =
	GetCurrentAccountQuery["getCurrentAccount"];

export const getCurrentAccountQueryKey = () => ["getCurrentAccount"];

const getCurrentAccountQueryFn = async () => {
	return graphierQLNextClient<
		GetCurrentAccountQuery,
		GetCurrentAccountVariables
	>({
		query,
	}).then((res) => res.getCurrentAccount);
};

export const useGetCurrentAccount = (enabled?: boolean) => {
	return useQuery({
		enabled,
		queryKey: getCurrentAccountQueryKey(),
		queryFn: () => getCurrentAccountQueryFn(),
	});
};

export const useGetCurrentAccountCache = () => {
	return useGetCurrentAccount(false);
};

export const useGetCurrentAccountAsserted = () => {
	const { data, ...rest } = useGetCurrentAccount();
	if (!data) throw new Error("Data not available yet");

	return { ...rest, data };
};
